import { SimplifiedPersonalizeContent } from 'types/api/personalize'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

/* ----------------------------- DISCOUNT STORE ----------------------------- */
// This store is used to manage the selected discount and reactively
// update the details modal and page.

type DiscountState = {
  selectedDiscount: SimplifiedPersonalizeContent | null
}

type DiscountAction = {
  updateSelectedDiscount: (discount: SimplifiedPersonalizeContent) => void
}

export const useDiscountStore = create<DiscountState & DiscountAction>()(
  persist(
    (set) => ({
      selectedDiscount: null,
      updateSelectedDiscount: (discount: SimplifiedPersonalizeContent) =>
        set(() => ({ selectedDiscount: discount }))
    }),
    {
      name: 'selected-discount',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
